<template>
  <div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span style="font-weight: bolder;float: left">{{ $route.query.deptId ? '更新角色' : '新增角色' }}</span>
      </div>
      <div class="text item">
        <el-form
          label-position="top"
          :model="memberDept"
          :rules="rules"
          ref="ruleForm"
          class="demo-ruleForm">

          <el-row>
            <el-col :span="colSpan" :offset="colSpanOffSet">

              <el-form-item label="成员姓名" :size="inputFromSize">
                <el-input class="text-input" disabled v-model="memberDept.name"></el-input>
              </el-form-item>

            </el-col>

            <el-col :span="colSpan" :offset="colSpanOffSet+1">
              <el-form-item label="行政机构" :size="inputFromSize">
                <el-input class="text-input" disabled v-model="memberDept.majorName"></el-input>
              </el-form-item>
            </el-col>

          </el-row>
          <el-row>
            <el-col :span="colSpan" :offset="colSpanOffSet">
              <el-form-item label="非行政机构" :size="inputFromSize">
                <el-input v-if="!memberDept.departmentRlnVOS[0].edit" class="text-input" disabled
                          v-model="memberDept.departmentRlnVOS[0].name"></el-input>
                <yl-cascader
                  v-if="memberDept.departmentRlnVOS[0].edit"
                  class="inputText"
                  :props="{ checkStrictly: true }"
                  :options="department.data"
                  v-model="department.ids"
                  @change="handleDeptChange"
                  :show-all-levels="false"
                  clearable filterable>
                </yl-cascader>
              </el-form-item>
            </el-col>
            <el-col :span="colSpan" :offset="colSpanOffSet+1">
              <el-form-item label="角 色" :size="inputFromSize">
                <span v-for="(role,index) of roles" :key="index">
                  <div style="padding-bottom: 10px">
                     <el-switch
                       style="display: block;"
                       active-color="#5ed5d9"
                       inactive-color="#E9EEF3"
                       v-model="role.flag"
                       @change="geoMapChange(role,index,role.flag)"
                       :active-text="role.roleName"
                     />
                  </div>
                </span>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <el-form>
        <!--style="float: right; padding: 3px 0"往右浮动-->
        <el-form-item>
          <div style="text-align: center">
            <el-button type="info" size="small" @click="goBack">返回</el-button>
            <el-button type="primary" size="small" @click="triggerChecked('ruleForm')"
                       :loading="sureLoading">
              保存
            </el-button>
          </div>
        </el-form-item>
      </el-form>
    </el-card>
    <!--加载动画-->
    <animation :loadingDataVisible="loadingDataVisible"></animation>

    <el-dialog
      :visible.sync="showSaveVisible"
      :close-on-click-modal="false"
      width="30%">
      <span>是否保存修改的信息？</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" size="small" @click="showSaveVisible = false">取 消</el-button>
        <el-button type="primary" size="small" @click="sureSaveInfo">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import http from "@/utils/axios";
import cookie from "@/utils/cookie";
import {Message} from "element-ui";
import animation from '@/components/loading/animation'
import {mapState} from "vuex";

export default {
  name: "MemberDepartmentUpdate",
  components: {animation},
  data() {
    return {
      loadingDataVisible: false,
      //设置等级为5的才显示科室
      //保存提示框是否可见
      showSaveVisible: false,
      colSpanOffSet: 1,
      colSpan: 10,
      sureLoading: false,
      inputFromSize: "small",
      //机构集合
      department: {
        data: [],
        ids: [],
      },
      //角色集合
      roles: [
        {
          flag: false,
          roleCode: '',
          roleName: '',
        }
      ],
      //成员机构关系
      memberDept: {
        userId: "",
        name: "",
        majorId: null,
        majorName: "",
        majorTp: "",
        departmentRlnVOS: [
          {
            id: null,
            departmentId: null,
            name: "",
            tp: "",
            roleCode: "",
            roleName: "",
            edit: false,
          },
        ],
      },
      rules: {
        name: [
          {required: true, message: '请输入机构名称', trigger: 'blur'},
          {min: 1, max: 32, message: '长度在 32 个字符之内', trigger: 'blur'}
        ],
        parent: [
          {required: true, message: '请输入上级机构', trigger: 'blur'}
        ],
      },
    }
  }
  ,
  mounted() {
    this.memberDept.userId = this.$route.query.userId
    this.initData()
    this.findUserDept()
  },
  watch: {
    treeDeptData(newVal) {
      this.department.data = newVal
    }
  },

  computed: mapState({
    treeDeptData: state => state.departmentStore.treeDeptData,
  }),

  methods: {

    //解决点击切换按钮无法切换的问题
    geoMapChange(e, i, flag) {
      for (let j = 0; j <this.roles.length; j++) {
        if (i===j){
          this.$set(this.roles, i, this.roles[i]);
        }else {
          this.roles[j].flag = false
        }
      }

    },

    sureSaveInfo() {
      this.sureLoading = true
      this.loadingDataVisible = true

      let roleCodes = []
      //准备需要修改的非行政机构的数据
      for (let role of this.roles) {
        if (role.flag) {
          roleCodes.push(role.roleCode)
        }
      }
      //将角色拼接成一个字符串
      let roleCodeStr = roleCodes.join(this.$store.state.userPowerStore.ROLE_CODE_OR_NAME_SEPARATOR)
      this.memberDept.departmentRlnVOS[0].roleCode = roleCodeStr

      if (this.$route.query.deptId) {
        let obj = {
          token: cookie.getCookie("token"),
          data: {
            memberDepartmentRln: this.memberDept
          }
        }
        //修改数据
        http.post(window.config.api.baseUrl + '/eims-api/memberDept/update', obj).then(value => {
          if (value.data.code === '00000') {
            Message.success({message: '成员信息修改成功', showClose: true})
            this.$store.dispatch("clearMemberDeptData")
            this.$router.push({
              path: "/user/role/manage",
            })
          }
        }).finally(() => {
          this.loadingDataVisible = false
          this.showSaveVisible = false
          this.sureLoading = false
        })
      } else {
        let obj = {
          token: cookie.getCookie("token"),
          data: {
            userId: this.memberDept.userId,
            departmentId: this.memberDept.departmentRlnVOS[0].departmentId,
            roleCode: this.memberDept.departmentRlnVOS[0].roleCode
          }
        }
        //添加数据
        http.post(window.config.api.baseUrl + '/eims-api/memberDept/create', obj).then(value => {
          if (value.data.code === '00000') {
            Message.success({message: '成员信息添加成功', showClose: true})
            this.$store.dispatch("clearMemberDeptData")
            this.$router.push({
              path: "/user/role/manage",
            })
          }
        }).finally(() => {
          this.loadingDataVisible = false
          this.showSaveVisible = false
          this.sureLoading = false
        })
      }

    },

    //移除关系
    removeMemberDept(row, index) {
      this.memberDept.departmentRlnVOS.splice(index, 1)
    },

    //级联选择器选项发生变化
    handleDeptChange() {
      this.memberDept.departmentRlnVOS[0].departmentId = this.department.ids[this.department.ids.length - 1]
    },

    //校验参数
    triggerChecked(formName) {
      let flag = false;
      //validate触发检验
      this.$refs[formName].validate((valid) => {
        flag = valid;
      });
      if (!flag) {
        return
      }
      if (!this.memberDept.departmentRlnVOS[0].departmentId) {
        Message.error({message: '添加的机构不能为空', showClose: true})
        return;
      }
      let count = 0;
      for (let role of this.roles) {
        if (role.flag) {
          count++;
        }
      }
      if (count === 0){
        Message.error({message: '至少为用户设置一个角色', showClose: true})
        return;
      }
      this.showSaveVisible = true
    },

    addMemberDeptInfo() {
      //设置新增的数据可以编辑
      this.memberDept.departmentRlnVOS.push({
        edit: true,
        roleCode: this.roles[this.roles.length - 1].roleCode
      })
    },

    goBack() {
      this.$router.back()
    },

    //初始化页面需要准备的数据
    initData() {
      let obj = {
        token: cookie.getCookie("token"),
        data: {}
      }
      http.post(window.config.api.baseUrl + '/eims-api/role/list', obj).then(value => {
        if (value.data.code === '00000') {
          this.roles = value.data.data.roles
        }
        for (let role of this.roles) {
          role.flag = false
        }
      })

      this.$store.dispatch("loadingTreeDeptData")
    },

    //查询用户相关的信息
    findUserDept() {
      // this.loadingDataVisible = true
      let obj = {
        token: cookie.getCookie("token"),
        data: {
          deptId: this.$route.query.deptId,
          userId: this.memberDept.userId
        }
      }
      http.post(window.config.api.baseUrl + '/eims-api/memberDept/findById', obj).then(value => {
        if (value.data.code === '00000') {
          this.memberDept = value.data.data.memberDepartmentRln
          //给新增的数据添加第一个非行政机构的信息,否则组件未初始化数据,数据会出现无法修改的问题
          if (!this.memberDept.departmentRlnVOS) {
            this.memberDept.departmentRlnVOS = []
            this.memberDept.departmentRlnVOS.push({
              id: null,
              name: "",
              tp: "",
              roleCode: "",
              roleName: "",
              edit: true,
            })
          }
          for (let departmentRln of this.memberDept.departmentRlnVOS) {
            //利用顿号切割成数组
            let roleCodes = departmentRln.roleCode.split(this.$store.state.userPowerStore.ROLE_CODE_OR_NAME_SEPARATOR)
            for (let role of this.roles) {
              if (roleCodes.includes(role.roleCode)) {
                role.flag = true
              }
            }
          }
        }
      }).finally(() => {
        this.loadingDataVisible = false
      })
    }

  },


}
</script>

<style scoped>

.box-card {
  width: 100%;
  border-radius: 10px
}

.text {
  font-size: 14px;
}

.item {
  text-align: left;
  margin-bottom: 18px;
}


.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both
}

/deep/ .el-radio__input.is-checked .el-radio__inner {
  background-color: transparent;
}

/deep/ .el-radio__inner {
  border: 0px;
  background-color: transparent;
}

/deep/ .el-radio__inner::after {
  background-color: transparent;
}

/deep/ .el-radio__label {
  padding-left: 3px;
}


/deep/ .customTable > .el-table th.el-table__cell {
  display: none;
}

/*隐藏element-ui的小圆点*/
/deep/ .el-radio__input.is-checked .el-radio__inner::after {
  content: '';
}

/*使用伪类设置选中的小图标*/
/deep/ .el-radio__input.is-checked + .el-radio__label:after {
  content: '✔';
  padding-left: 10px;
}


</style>



// WEBPACK FOOTER //
// src/pages/user/MemberRoleUpdate.vue